import { merge } from 'lodash';
import moment from 'moment';
import 'moment-timezone';

const apiGetFiltersDefault = {
  include: [],
  limit: 0,
  page: 0,
  params: [],
  filters: [],
  search: null,
  sort: null,
};

const Utils = {
  userHasPermission: (user, routePermissions) => {
    if (!routePermissions) return true;

    let hasPermission = false;

    const permissions = user.permissions.map((permission) => permission.name);
    routePermissions.forEach((permission) => {
      if (permissions.includes(permission)) {
        hasPermission = true;
      }
    });

    return hasPermission;
  },
  userHasRole: (user, routeRoles) => {
    if (!routeRoles) return true;

    let hasRole = false;
    const roles = user.roles.map((role) => role.name);
    routeRoles.forEach((role) => {
      if (roles.includes(role)) {
        hasRole = true;
      }
    });

    return hasRole;
  },
  getApiFilters(filtersCustom) {
    const filters = { ...apiGetFiltersDefault };
    if (filtersCustom != null) {
      filters.include = filtersCustom.include != null ? filtersCustom.include : filters.include;
      filters.page = filtersCustom.page != null ? filtersCustom.page : filters.page;
      filters.limit = filtersCustom.limit != null ? filtersCustom.limit : filters.limit;
      filters.params = filtersCustom.params != null ? filtersCustom.params : filters.params;
      filters.filters = filtersCustom.filters != null ? filtersCustom.filters : filters.filters;
      filters.search = filtersCustom.search != null ? filtersCustom.search : filters.search;
      filters.sort = filtersCustom.sort != null ? filtersCustom.sort : filters.sort;
    }
    return filters;
  },
  convertDateToUserTimezone(utcDate, format = '') {
    if (utcDate) {
      const timezone = moment.tz.guess();

      // Convert the UTC date to the user's timezone
      const localDateTime = moment.utc(utcDate).tz(timezone);

      // Get the browser's locale settings
      const locale = navigator.language;

      // Format the date according to the browser's locale settings
      let formattedDate = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      }).format(localDateTime.toDate());

      if (format) {
        formattedDate = moment(formattedDate).format(format);
      }

      return formattedDate;
    }
    return '';
  },
  getCustomFieldTypes() {
    return [
      { id: 'string', title: 'Short Text' },
      { id: 'text', title: 'Long Text' },
      { id: 'integer', title: 'Integer Number' },
      { id: 'decimal', title: 'Decimal Number' },
      { id: 'date', title: 'Date' },
      { id: 'boolean', title: 'Yes/No (Checkbox)' },
      { id: 'datetime', title: 'Date & Time' },
      { id: 'time', title: 'Time' },
      { id: 'radio-list', title: 'Single Choice (Radio)' },
      { id: 'url', title: 'Url' },
    ];
  },
};

export const getSlice = (listname = 'slice', data = null) => {
  const slice = {
    stateListName: listname,
    dataUrl: {},
    getFilters: {
      include: [],
      limit: 10,
      page: 0,
      params: [],
      filters: [],
      search: '',
      sort: '',
    },
    dataList: {
      showPageLoading: false,
      successHandle: null,
    },
    dataUpdate: {
      id: null,
      data: null,
      successHandle: null,
      disableAutoUpdate: false,
    },
    dataCreate: {
      data: null,
      successHandle: null,
    },
    dataDelete: {
      id: null,
      successHandle: null,
    },
    errorHandle: null,
  };

  return data ? merge(slice, data) : slice;
};

export default Utils;
